import * as tslib_1 from "tslib";
import { Injectable } from '@angular/core';
let JqHelper = class JqHelper {
    initDataTable() {
        $('.datatable').DataTable({
            'retrieve': true,
            info: false,
            searching: false,
            language: {
                zeroRecords: " "
            }
        });
        // $('#datatable').DataTable();
    }
    reinitDataTable(mdata) {
        // $('.datatable').rows.add(mdata).draw();
        $('#brandTable').DataTable({
            'retrieve': true,
        }).rows.add(mdata).draw();
        // columns: [{
        //   title: 'Name',
        //   data: 'Name'
        // }, {
        //   title: 'Actions'
        // }],
        // data: mdata
    }
    initializeDataTable() {
        $(".datatable").DataTable({
            paging: false,
            info: false,
            searching: false,
            retrieve: true,
            language: {
                zeroRecords: " "
            },
        });
    }
    clearDataTable() {
        $('.datatable').DataTable().clear(true);
    }
    destoryDataTable() {
        $('.datatable').DataTable().destroy(true);
    }
    refreshDataTable() {
        this.destoryDataTable();
        this.initDataTable();
    }
    hideSplashScreen() {
        setTimeout(() => {
            $('#status').fadeOut();
            $('#preloader').delay(350).fadeOut('slow');
            $('body').delay(350).css({
                'overflow': 'visible'
            });
        }, 300);
    }
    showSpinner(opt = false) {
        if (opt == true) {
            $('.spinner').show();
        }
        else {
            $('.spinner').hide();
        }
    }
    loginLoading(opt = false) {
        if (opt == true) {
            $('#loginBtn').delay(250).hide('slow');
            $('.spinner').delay(350).fadeIn('slow');
        }
        else {
            $('.spinner').delay(350).fadeOut('slow');
            $('#loginBtn').delay(1000).show('slow');
        }
    }
};
JqHelper = tslib_1.__decorate([
    Injectable({
        providedIn: 'root'
    })
], JqHelper);
export { JqHelper };
//# sourceMappingURL=jq-helper.js.map